import { Component, Input, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-map-filter',
  templateUrl: './map-filter.component.html',
  styleUrls: ['./map-filter.component.scss'],
})
export class MapFilterComponent extends BaseModal implements OnInit {
  selectedItem
  @Input() id: number;
  @Input() selected: string = "IsPestTrap"
  filterList = [
    {
      Id: "IsHighPest",
      title: "sudden-increase-fields",
      icon: 'bug-outline',
      color: "#f6b76c"
    },
    {
      Id: "IsFrostRisk",
      title: "frost-risk-status-fields",
      icon: 'snow-outline',
      color: "#41a6ef"
    },
    {
      Id: "IsDiseaseRisk",
      title: "disease-risk-fields",
      icon: '../../../../../../assets/icon/disease.svg',
      color: "#f85b5b"
    },
    {
      Id: "IsHarvestSeason",
      title: "harvest-season-fields",
      icon: '../../../../../../assets/icon/harvest.svg',
      color: "#82bd5f"
    },
    {
      Id: "IsScoutingNote",
      title: "scouting-notes-fields",
      icon: '../../../../../../assets/icon/scouting.svg',
      color: "#ffffff"
    },
    {
      Id: "IsPestTrap",
      title: "trap-fields",
      icon: '../../../../../../assets/icon/trap-icon.svg',
      color: "#8483b0"
    },
    {
      Id: "IsFiliz",
      title: "filiz-fields",
      icon: '../../../../../../assets/icon/filiz-map-icon.svg',
      color: "#4c9a31"
    }
  ]
  constructor(private modalService: ModalService) {
    super();
    super._modalService = modalService;
  }

  ngOnInit() {
    this.selectedItem = this.filterList.find(e => e.Id == this.selected);
  }

  save() {
    this.modalService.dismissByModalId(this.id, this.selectedItem, "map-filter");
  }
}
